import React from "react";
import { createPortal } from "react-dom";

// Last monthly buffet is 30 Aug 2026. From the next day on, it's weekly.
const LAST_MONTHLY_DATE = new Date(2026, 7, 30);

const PricePopup = ({ adultPrice, childPrice, onClose }) => {
  const isWeeklyLive = new Date() > LAST_MONTHLY_DATE;

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[1000]">
      <div className="bg-white text-black px-10 py-[30px] rounded-xl text-center w-[90%] max-w-sm shadow-[0_4px_15px_rgba(0,0,0,0.2)]">
        <h2 className="mb-[15px] font-bold text-2xl">Buffet Prices</h2>
        <p className="text-lg my-2.5">Adults: £{adultPrice.toFixed(2)}</p>
        <p className="text-lg my-2.5">Children: £{childPrice.toFixed(2)}</p>
        <div className="mt-4 p-3 bg-brand-orange/10 border-y border-brand-orange/30">
          <p className="text-base text-black m-0 font-bold">
            {isWeeklyLive ? "Every Sunday" : "Every last Sunday of the month"}
          </p>
        </div>
        <button
          className="mt-5 px-5 py-2 bg-[#f57c00] text-white border-none rounded cursor-pointer font-[inherit] text-xl hover:opacity-80"
          onClick={onClose}
        >
          Got it!
        </button>
      </div>
    </div>,
    document.body
  );
};

export default PricePopup;
